import { all, put, race, select, take, takeEvery } from 'redux-saga/effects'
import { startSubmit, stopSubmit } from 'redux-form'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import { FORM_ID, SUBMIT_CHANGE_PASSWORD_FORM, CHANGE_PASSWORD_REQUEST } from './constants'

import { changePasswordRequest } from './actions'
import { showLoader, hideLoader } from '../../../Loader/actions'

import { sessionIdSelector } from './selectors'

const CHANGE_PASSWORD_REQUEST_SUCCESS = `${CHANGE_PASSWORD_REQUEST}_${SUCCESS}`
const CHANGE_PASSWORD_REQUEST_FAILED = `${CHANGE_PASSWORD_REQUEST}_${FAILED}`

function* handleUpdateProfile(_action) {
    const contentId = _action.data.contentId || null
    const currentPassword = _action.data.values.get('currentPassword', '')
    const newPassword = _action.data.values.get('newPassword', '')

    if (!contentId) return null

    yield put(startSubmit(FORM_ID))
    yield put(showLoader(contentId))

    const sessionId = yield select(sessionIdSelector)

    // update data
    const result = yield all({
        response: race({
            success: take(CHANGE_PASSWORD_REQUEST_SUCCESS),
            failed: take(CHANGE_PASSWORD_REQUEST_FAILED),
        }),
        request: put(changePasswordRequest(sessionId, currentPassword, newPassword)),
    })

    if (result.response.success) {
        yield put(stopSubmit(FORM_ID))
    } else {
        const errorCode = _.get(result, 'response.failed.payload.error.code', 500)

        if (errorCode === 400) {
            yield put(stopSubmit(FORM_ID, { _error: 'wrongCurrentPassword' }))
        } else {
            yield put(stopSubmit(FORM_ID, { _error: 'async' }))
        }
    }

    yield put(hideLoader(contentId))

    return null
}

export default function* editProfileFormSaga() {
    yield all([takeEvery(SUBMIT_CHANGE_PASSWORD_FORM, handleUpdateProfile)])
}
